import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];
  static values = {
    enabled: { type: Boolean, default: true },
  };

  connect() {
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener("input", this.handleInput.bind(this));
    }
  }

  disconnect() {
    if (this.hasInputTarget) {
      this.inputTarget.removeEventListener(
        "input",
        this.handleInput.bind(this),
      );
    }
  }

  toggleAutoCapitalize(event) {
    this.enabledValue = event.target.checked;
  }

  handleInput(event) {
    if (this.enabledValue) {
      event.target.value = this.titleCase(event.target.value);
    }
  }

  titleCase(str) {
    return str.replace(/\w\S*/g, (text) => {
      return text.charAt(0).toUpperCase() + text.substr(1).toLowerCase();
    });
  }
}
